import { Container, Toolbar, MenuItem } from '@mui/material';
import { useSelector } from 'react-redux';
import ToolbarSelect from './ToolbarSelect';
import { selectors } from '../../store/dux/field-agrilytics-dux';
import { selectors as fieldSelectors } from '../../store/dux/fields-dux';

export default function FieldAgrilyticsToolbar(props) {
  const { mapScope, onFieldSelection, onVersionSelection } = props;

  const fieldRevisions = useSelector(selectors.fieldRevisions(mapScope));
  const selectedField = useSelector(selectors.selectedField(mapScope)) || '';
  const selectedRevision =
    useSelector(selectors.selectedRevision(mapScope)) || null;
  const fields = useSelector(fieldSelectors.growerFields);

  return (
    <Container
      maxWidth={false}
      sx={{
        '& .MuiFormControl-root': { paddingRight: '1.5rem' },
        '& .MuiNativeSelect-root:after, & .MuiNativeSelect-root:before, & .MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before':
          {
            borderBottomColor: '#fff',
          },
        '& .MuiNativeSelect-icon, & .MuiInputLabel-root.Mui-focused': {
          color: '#fff',
        },
      }}
    >
      <Toolbar>
        <ToolbarSelect
          value={selectedField}
          inputProps={{
            name: `${mapScope}FieldSelection`,
            id: `${mapScope}-field-selection`,
          }}
          onChange={onChangeHandler(onFieldSelection)}
          label="Field"
          {...(!fields.length || !selectedField
            ? {
                renderValue: () => 'Select Field',
                displayEmpty: true,
              }
            : {})}
        >
          {fields.map((field) => (
            <MenuItem value={field.aaManagedId} key={field.aaManagedId}>
              {field.fieldName}
            </MenuItem>
          ))}
        </ToolbarSelect>

        <ToolbarSelect
          label="Version"
          value={selectedRevision?.id || ''}
          inputProps={{
            name: `${mapScope}VersionSelection`,
            id: `${mapScope}-version-selection`,
          }}
          onChange={onChangeHandler(onVersionSelection)}
          {...(!fieldRevisions.length
            ? {
                renderValue: () => 'Select Version',
                displayEmpty: true,
              }
            : {})}
        >
          {fieldRevisions.map((revision, i) => (
            <MenuItem
              value={revision.id}
              key={revision.id}
              sx={{ alignItems: 'baseline' }}
            >
              {`Ver ${fieldRevisions.length - i}`}
              <span style={{ fontSize: '.8rem', paddingLeft: '.5rem' }}>
                {formatRevisionDate(revision.endsAt)}
              </span>
            </MenuItem>
          ))}
        </ToolbarSelect>
      </Toolbar>
    </Container>
  );

  function formatRevisionDate(dateStr) {
    const revisionDate = dateStr ? new Date(dateStr) : null;
    return revisionDate
      ? revisionDate.toLocaleDateString().replace(/\//g, '-')
      : 'Current';
  }

  function onChangeHandler(handler) {
    return (event) => handler(event.target.value);
  }
}
